import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { selectDishTypes } from "slices/dishesSlice";
import type { LocalDishType } from "types/mainTypes";

export const useDishTypes = (): { data: LocalDishType[] } => {
	const dishTypes = useAppSelector(selectDishTypes) || [];
	return {
		data: dishTypes,
	};
};
